import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';
import { PURCHASE_ORDER_PATH } from 'domain/finance/purchaseOrder/usePurchaseOrderService';

export const usePurchaseOrderUrl = () => {
  const baseUrls = useEntityUrl({ baseLink: PURCHASE_ORDER_PATH });

  return { ...baseUrls, getCopyEntityUrl: (id?: string): string => `${baseUrls.getSingleEntityUrl(id)}/copy` };
};

export const usePurchaseOrderId = () => useParams<Dictionary<string>>().id!;
